import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { upsertReservationNote } from 'modules/accommodations/features/reservations/api';

export const useMutationReservationNote = () => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(upsertReservationNote, {
    onSuccess: () => {
      successToast(t('You have successfully saved the note'));
      queryClient.refetchQueries(QUERY_KEYS.UNITS_RESERVATION_TYPE);
    },
    onError: () => errorToast(),
  });
};
